import React from 'react'

export const GoogleIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style} className='icon--social icon--social-google'
    viewBox='0 0 32 32'
  >
    <path
      className='st0' d='M7.8,19.1l-1,3.8l-3.7,0.1C2,20.9,1.3,18.5,1.3,16c0-2.4,0.6-4.7,1.6-6.7h0l3.3,0.6l1.5,3.3C7.5,14.1,7.3,15,7.3,16C7.3,17.1,7.5,18.1,7.8,19.1z'
    />
    <path
      className='st1' d='M30.4,13.3c0.2,0.9,0.3,1.8,0.3,2.7c0,1-0.1,2.1-0.3,3.1c-0.7,3.4-2.6,6.3-5.2,8.4l0,0L21,27.2l-0.6-3.7c1.7-1,3.1-2.6,3.8-4.5h-7.8v-5.8h7.9H30.4L30.4,13.3z'
    />
    <path
      className='st2' d='M25.2,27.4L25.2,27.4c-2.5,2-5.7,3.2-9.2,3.2c-5.6,0-10.4-3.1-12.9-7.7l4.7-3.9c1.2,3.3,4.4,5.7,8.2,5.7c1.6,0,3.1-0.4,4.4-1.2L25.2,27.4z'
    />
    <path
      className='st3' d='M25.4,4.7l-4.7,3.9c-1.3-0.8-2.9-1.3-4.6-1.3c-3.8,0-7.1,2.5-8.2,5.9L3,9.3h0c2.4-4.7,7.4-7.9,13-7.9C19.6,1.3,22.8,2.6,25.4,4.7z'
    />
  </svg>
)
